import PROFILE_AKASH from '../images/akash_biswas.jpg';
import PROFILE_DEBAJYOTI from '../images/debajyoti_mandal.jpeg';
import PROFILE_DIKSHA from '../images/diksha_singh.jpg';
import PROFILE_MKS from '../images/mks_logo.png';
import PROFILE_RAJVEER from '../images/rajveer_singh.jpg';
import PROFILE_SUDIPA from '../images/sudipa_mohanta.jpeg';

export const FeedBacks = [
    {
        designation: 'Captain, CPTI',
        feedback:
            'I highly recommend Vesis for website upgrades, improving rankings and digital marketing. Their expertise in optimizing our online presence and implementing effective strategies has significantly boosted our conversions. Vesis delivers professional and innovative solutions, making them a reliable partner for buisness growth.',
        id: 1,
        linkedinUrl: 'https://www.linkedin.com/in/rajveer-singh-7163a9139/',
        name: 'Rajveer Singh',
        profileImg: PROFILE_RAJVEER,
    },
    {
        designation: 'President, Subash Bose Welfare Association',
        feedback:
            'As the President of the Subash Bose Welfare Association, I am thrilled to share my appreciation for the exceptional work done by the website development team. The website they created for our association is not only visually appealing but also functions seamlessly, making it easier for us to connect with our community and share our initiatives. Their professionalism, attention to detail, and dedication to our vision have exceeded our expectations. We are grateful for their efforts in bringing our digital presence to life and look forward to a continued partnership. Thank you for your outstanding service!',
        id: 2,
        linkedinUrl: 'https://www.linkedin.com/in/akashbiswas27/',
        name: 'Akash Biswas',
        profileImg: PROFILE_AKASH,
    },
    {
        designation: 'Sr. Consultant, Capgemini',
        feedback:
            'Vesis Solution provides top-notch services with a strong focus on quality and customer satisfaction. Their expertise and professionalism make them a trusted choice for businesses looking for reliable solutions. They helped me to setup me technicalblog.in site and with their help in seo my overall traffic increase so much.',
        id: 3,
        linkedinUrl: 'https://www.linkedin.com/in/diksha-singh-5385ba212/',
        name: 'Diksha Singh',
        profileImg: PROFILE_DIKSHA,
    },
    {
        designation: 'Founder, TailDelights',
        feedback:
            "Working with Vesis to design the TailDelights website was an incredible experience! They perfectly captured our vision, creating a visually stunning, user-friendly site that makes it easy for pet owners to explore our services and book appointments. Their attention to detail, responsiveness, and creativity exceeded our expectations, and we've received amazing feedback from our clients. Thanks to their expertise, TailDelights now has a strong online presence that truly reflects our passion for pet care!",
        id: 4,
        linkedinUrl: 'https://www.linkedin.com/in/debajyoti-mandal-67a850192/',
        name: 'Debajyoti Mandal',
        profileImg: PROFILE_DEBAJYOTI,
    },
    {
        designation: 'Secretary of MKS Organization',
        feedback:
            'We are extremely pleased with the development of MauryaSamaj.in, which perfectly represents our community with a user-friendly design, seamless navigation, and optimized performance across devices. The development team demonstrated professionalism by incorporating essential features like community forums, event listings, and secure contact forms, ensuring an engaging and interactive platform. Their attention to detail, timely delivery, and willingness to accommodate our suggestions made the entire process smooth. We highly recommend their services to anyone seeking a reliable and skilled web development team. Thank you for bringing our vision to life!',
        id: 5,
        linkedinUrl: 'https://www.linkedin.com/in/maurya-kushwaha-samaj-thane-540337178/',
        name: 'Shitla Maurya',
        profileImg: PROFILE_MKS,
    },
    {
        designation: 'General Manager and Head of SW Design Authority, Ericsson',
        feedback:
            'Worked with Vesis for UI/UX development of an Mobile application in domain of Astrology. Team did really good. They are professional, maintained timeline and very responsive and innovative. Always recommend them for future projects.',
        id: 6,
        linkedinUrl:
            'https://www.linkedin.com/in/sudipa-mohanta-kol8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
        name: 'Sudipa Mohanta',
        profileImg: PROFILE_SUDIPA,
    },
];
